var Marionette = require('backbone.marionette');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var DocumentTypesRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/document-types/document-types-row.html'),
    events: {
        'click #delete': 'remove',
        'click #edit': 'edit'
    },

    templateContext: function () {
        return {
            organization: this.getOrgName(this.model.get('organizationId'))
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'remove', 'edit');
        this.getOrgName = options.getOrgName;
    },

    remove: function (event) {
        this.triggerMethod('delete:model', this.model);
    },

    edit: function (event) {
        this.triggerMethod('update:model', this.model);
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(5), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var DocumentTypesTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: DocumentTypesRowView,
    emptyView: EmptyView,

    childViewEvents: {
        'update:model': 'updateModel',
        'delete:model': 'deleteModel'
    },

    childViewOptions: function () {
        return {
            getOrgName: this.getOrgName
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'updateModel', 'deleteModel');
        this.collection = options.collection;
        this.getOrgName = options.getOrgName;
    },

    updateModel: function (model) {
        var that = this;
        var callback = function () {
            that.triggerMethod('on:update', model);
        }
        this.triggerMethod('on:action', {callback: callback, mode: 'update'});
    },

    deleteModel: function (model) {
        var that = this;
        var callback = function () {
            that.triggerMethod('on:delete', model);
        }
        this.triggerMethod('on:action', {callback: callback, mode: 'delete'});
    }
});

var DocumentTypesTableView = Marionette.View.extend({
    tagName: 'div',
    className: 'document-types-table',
    template: require('../../templates/document-types/document-types-table.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        updateConfirmationModal: '#yes-no-confirmation-modal-for-update',
        deleteConfirmationModal: '#yes-no-confirmation-modal-for-delete'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed',
        'on:action': 'onAction',
        'on:update': 'onUpdate',
        'on:delete': 'onDelete'
    },

    ui: {
        addBtn: '#add-document-type',
        updateConfirmationModal: '#yes-no-confirmation-modal-for-update',
        deleteConfirmationModal: '#yes-no-confirmation-modal-for-delete'
    },

    events: {
        'click @ui.addBtn': 'add'
    },

    callback: undefined,

    templateContext: function () {
        return {}
    },

    onRender: function () {
        this.showChildView('body', new DocumentTypesTableBody({
            collection: this.collection,
            getOrgName: this.getOrgName
        }));

        this.updateConfirmationModal = new YesNoConfirmationModal({
            title: 'Update confirmation',
            message: 'You are going to update document type. Are you sure?'
        });
        this.showChildView('updateConfirmationModal', this.updateConfirmationModal);

        this.deleteConfirmationModal = new YesNoConfirmationModal({
            title: 'Remove confirmation',
            message: 'You are going to remove document type. Are you sure?'
        });
        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
    },

    initialize: function (options) {
        _.bindAll(this, 'saveConfirmed', 'onAction', 'add', 'onDelete', 'onUpdate');
        this.collection = options.collection;
        this.getOrgName = options.getOrgName;
    },

    onAction: function (data) {
        this.callback = data.callback;
        if (typeof this.callback !== "function")
            return;
        if (data.mode == 'update') {
            this.updateConfirmationModal.show();
        } else if (data.mode == 'delete') {
            this.deleteConfirmationModal.show();
        }
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.updateConfirmationModal.hide();
            this.deleteConfirmationModal.hide();
        }
    },

    add: function () {
        this.triggerMethod('on:new', null);
        this.hideButton();
    },

    showButton: function () {
        this.ui.addBtn.show();
    },

    hideButton: function () {
        this.ui.addBtn.hide();
    },

    onUpdate: function(model) {
        this.triggerMethod('on:update', model);
    },

    onDelete: function(model) {
        this.triggerMethod('on:delete', model);
    }
});

module.exports = DocumentTypesTableView;


//////////////////
// WEBPACK FOOTER
// ./app/views/document-types/document-types-table.js
// module id = 456
// module chunks = 0